import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import MenteeDashboard from "./pages/MenteeDashboard";
import MentorDashboard from "./pages/MentorDashboard";
import Profile from "./pages/Profile";
import MentorProfile from "./pages/MentorProfile";
import SearchMentors from "./pages/SearchMentors";
import MenteeProfile from "./pages/MenteeProfile";
import Messages from "./pages/Messages";
import Admin from "./pages/Admin";
import MyAcademy from "./pages/MyAcademy";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import MentorAgreement from "./pages/MentorAgreement";
import RefundPolicy from "./pages/RefundPolicy";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Account from "./pages/Account";
import Notifications from "./pages/Notifications";
import Calendar from "./pages/Calendar";
import MenteeCalendar from "./pages/MenteeCalendar";
import NotFound from "./pages/NotFound";
import AuthConfirm from "./pages/AuthConfirm";
import EmailVerification from "./pages/EmailVerification";
import AwaitingApproval from "./pages/AwaitingApproval";
import { EmailVerificationWrapper } from "./components/EmailVerificationWrapper";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <EmailVerificationWrapper>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth/confirm" element={<AuthConfirm />} />
              <Route path="/email-verification" element={<EmailVerification />} />
              <Route path="/awaiting-approval" element={<AwaitingApproval />} />
              <Route path="/login" element={<Login />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/mentee-dashboard" element={<MenteeDashboard />} />
            <Route path="/mentor-dashboard" element={<MentorDashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/mentor-profile" element={<MentorProfile />} />
            <Route path="/mentor-profile/:id" element={<MentorProfile />} />
            <Route path="/search-mentors" element={<SearchMentors />} />
            <Route path="/mentee-profile/:id" element={<MenteeProfile />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:conversationId" element={<Messages />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/my-academy" element={<MyAcademy />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/mentor-agreement" element={<MentorAgreement />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/payment/:applicationId" element={<Payment />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/account" element={<Account />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/mentee-calendar" element={<MenteeCalendar />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </EmailVerificationWrapper>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
